module.exports = __webpack_public_path__ + "img/derive-pdf.29fbefda.svg";